export default class ResourceDto {
    /**
     * @type{number}
     */
    rsId;

    /**
     * @type{string}
     */
    rsTitle;

    /**
     * @type{string}
     */
    rsShortDescription;

    /**
     * @type{Date}
     */
    rsCreatedUtc;

    /**
     * @type{Date}
     */
    rsUpdatedUtc;

    /**
     * @type{string}
     */
    rsContent;

    /**
     * @type{string}
     */
    resourceType;

    /**
     * @type{number}
     */
    resourceAttachmentId;

    /**
     * @type{ResourceAttachmentDto}
     */
    resourceAttachment;

    /**
     * @type{number}
     */
    resourceImageId;

    /**
     * @type{ResourceAttachmentDto}
     */
    resourceImage;

    /**
     * @type{Array<ResourceTopicDto>}
     */
    resourceTopics;

    /**
     * @type{Array<SimpleOrganizationDto>}
     */
    ctOrgs

    /**
     * @type{boolean}
     */
    isPublic;

    constructor () {
        this.rsId = 0;
        this.rsTitle = '';
        this.rsShortDescription = '';
        this.rsContent = ''
        this.resourceType = '';
        this.resourceLink = '';
        this.resourceImageLink = '';
        this.resourceTopics = [];
        this.isPublic = false;
    }
}
